import 'babel-polyfill'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-toast-notification/dist/index.css'

// import './assets/scss/fonts.css'
import './assets/scss/font-icons.css'
import './assets/scss/main.css'

//import './assets/scss/style.css'
// import './assets/scss/pages/lesson.css'
import '@/assets/scss/app.scss'


import VueKonva from 'vue-konva'
import VueLazyload from 'vue-lazyload'
import VueHead from 'vue-head'
import VueHotkey from 'v-hotkey'
import FullCalendar from 'vue-full-calendar'
import Vuelidate from 'vuelidate'
import VueToast from 'vue-toast-notification'
import Bus from './helpers/eventbus'


// Layouts
import Default from '@/layouts/Default'
import Guest from '@/layouts/Guest'
import Auth from '@/layouts/Auth'
import Simple from '@/layouts/Simple'
// import Lesson from './layouts/Lesson.vue'
import OnlyBody from './layouts/OnlyBody.vue'
import VueDraggable from 'vue-draggable'
// import './utils/messageHub.js'
import VueAnalytics from 'vue-analytics';
// import vueHeadful from 'vue-headful';


import VueProgressBar from 'vue-progressbar'
// import loader from "vue-ui-preloader";

import VueCookies from 'vue-cookies'
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

import '@/helpers/disabledDebug'

// const imgLoading = require('./assets/images/loading.gif')
const img404 = require('./assets/images/img_404.jpg')
// Tell Vue to use the plugin
Vue.use(VueCookies);
Vue.$cookies.config('1d')
// Vue.use(VueHtml2Canvas);
// Bootstrap
Vue.use(BootstrapVue)
// SEO Metas
Vue.use(VueMeta)
// Vue.use(require('vue-shortkey'))
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: img404,
    loading: '',
    attempt: 1
})

Vue.use(FullCalendar)
// Evt bus
Vue.use(Bus)
Vue.use(Vuelidate)
Vue.use(VueHotkey)
// Bootstrap
Vue.use(BootstrapVue)

// Vue toast
Vue.use(VueToast, { position: 'top-right' })

// VueDraggable
Vue.use(VueDraggable)

Vue.component('default-layout', Default)
Vue.component('guest-layout', Guest)
Vue.component('auth-layout', Auth)
Vue.component('simple-layout', Simple)
Vue.component('onlybody-layout', OnlyBody)

Vue.config.productionTip = false
Vue.use(VueHead)

Vue.use(VueKonva)
// Configuration VueAnalytics
Vue.use(VueAnalytics, {
    id: 'UA-158744101-1'
});
///
const optionsProgressBar = {
    color: '#3490dc',
    failedColor: '#874b4b',
    thickness: '3px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}

Vue.use(VueProgressBar, optionsProgressBar)



import { APP_CONFIG } from "@/utils/constants";
import Keycloak from 'keycloak-js';
import JWT from "@/utils/jwt"
async function checkAuthencation() {
    /// kiểm tra nếu bên tập huấn đã đăng nhập rồi thì tự động đăng nhập
    const request = await fetch(APP_CONFIG.dataUrl + "IsLoginkeyCloak");
    const response = await request.json();
    if (response.isLoginKeyClock == 1) {
        let initOptions = {
            url: response.urlServerKeyCloak, realm: response.realm, clientId: response.audienceWeb,
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
            checkLoginIframe: false,

        }
        let keycloak = Keycloak(initOptions);
        keycloak.init({ onLoad: initOptions.onLoad }).then(async (auth) => {
            // eslint-disable-next-line no-empty
            if (!auth) {
            } else {
                const dataResponse = await fetch(APP_CONFIG.dataUrl + "GetUserInfo", {
                    method: 'get',
                    headers: new Headers({
                        'Authorization': 'Bearer ' + keycloak.token,
                        'Content-Type': 'application/json'
                    })
                });
                const dataObject = await dataResponse.json();
                if (dataObject.userProfile) {
                    JWT.saveAuth(dataObject.userProfile)
                    let expired_in = (1 / 1440) * parseFloat(keycloak.tokenParsed.auth_time);
                    JWT.saveToken(keycloak.token, expired_in);
                    localStorage.setItem("refresh_token", keycloak.refreshToken)
                    location.reload();
                }

            }
        })


    }
}

if (!localStorage.getItem("refresh_token") && window.location.pathname != '/kiem-tra-xac-thuc') {

    (async () => {
        await checkAuthencation()
    })();
}



new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
